const COMPILED_CONSTANTS = {
    "evolveAppInferenceProfileArn": "arn:aws:bedrock:us-east-1:794038225525:application-inference-profile/o7qmiaxkc7ie",
    "evolveAppInferenceProfile46Arn": "arn:aws:bedrock:us-east-1:794038225525:application-inference-profile/fmhke7tojj59",
    "evolveContractIngestionApiGatewayId": "08rw3ivvg3",
    "evolveSettlementApiGatewayId": "99t2jwpzd5",
    "evolveNexusPublicApiGatewayId": "seg8ugun92",
    "evolveNexusApiGatewayId": "psmve67637",
    "evolveOSApiGatewayId": "0u7yum8l1f",
    "evolveApiAlertsTopicArn": "arn:aws:sns:us-east-1:794038225525:api-alerts-topic",
    "evolveNascoNexusRedshiftRole": "arn:aws:iam::794038225525:role/nasco-evolve-redshift-role-nexus",
    "evolveRedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:794038225525:workgroup/f040a400-9bcb-48c5-af2b-83d3a7be427e",
    "RedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:794038225525:workgroup/f040a400-9bcb-48c5-af2b-83d3a7be427e",
    "evolveRedshiftSnapshotLambdaRoleArn": "arn:aws:iam::794038225525:role/nasco-evolve-redshift-snapshot-lambda-role",
    "evolvenexusToProcessBucketName": "evolve-nexus-to-process-794038225525-us-east-1",
    "evolvemediaBucketName": "evolve-media-794038225525-us-east-1",
    "evolvesynthDataBucketName": "evolve-synth-data-794038225525-us-east-1",
    "evolveAwsAccountId": "794038225525",
    "evolvenexusFailedProcessingBucketName": "evolve-nexus-failed-processing-794038225525-us-east-1",
    "evolvemigrationBucketName": "evolve-migration-794038225525-us-east-1",
    "evolvereportsBucketName": "evolve-reports-794038225525-us-east-1",
    "evolvedevBucketName": "evolve-dev-794038225525-us-east-1",
    "evolvesettlementArtifactsBucketName": "evolve-settlement-artifacts-794038225525-us-east-1",
    "evolvenexusProcessedBucketName": "evolve-nexus-processed-794038225525-us-east-1",
    "evolvequarantineBucketName": "evolve-quarantine-794038225525-us-east-1",
    "evolvetemporaryBucketName": "evolve-temporary-794038225525-us-east-1",
    "evolveflowArtifactsBucketName": "evolve-flow-artifacts-794038225525-us-east-1",
    "evolvedynamoBucketName": "evolve-dynamo-794038225525-us-east-1",
    "evolvecontractUploadsBucketName": "evolve-contract-uploads-794038225525-us-east-1",
    "evolveexportDynamoBucketName": "evolve-export-dynamo-794038225525-us-east-1",
    "evolvememoriesBucketName": "evolve-memories-794038225525-us-east-1",
    "securityGroupId": "sg-0cdb03a14b33af379",
    "evolveUserPoolId": "us-east-1_bNV5hDVMv",
    "evolveGuardDutyMalwareAlertTopicArn": "arn:aws:sns:us-east-1:794038225525:guardduty-malware-alerts",
    "evolveUserPoolClientId": "7lvu643pqjfm7olfekvjpdrn4o",
    "evolveCognitoDomain": "vbc-794038225525-us-east-1",
    "evolveSecurityGroupId": "sg-0cdb03a14b33af379",
    "evolveNexusCloudFrontDistributionArn": "arn:aws:cloudfront::794038225525:distribution/E74KRDHH3J44W",
    "evolveNexusCloudFrontDistributionId": "E74KRDHH3J44W",
    "evolveNexusFrontendBucket": "evolve-nexus-frontend-794038225525-us-east-1",
    "evolveNexusSubDomain": "vbc.nexus",
    "evolveOSFrontendBucketName": "evolve-os-frontend-794038225525-us-east-1",
    "evolveOSCloudFrontDistributionArn": "arn:aws:cloudfront::794038225525:distribution/E2I0T589Q41JZU",
    "evolveOSSubDomain": "vbc.os",
    "evolveOSCloudFrontDistributionId": "E2I0T589Q41JZU",
    "evolveNascoDomain": "vbps.demo.nasco.com",
    "evolveApiProxyUrl": "https://vbc-proxy.vbps.demo.nasco.com",
    "evolveApiCloudFrontDistributionArn": "arn:aws:cloudfront::794038225525:distribution/E3JIVU1LQP4VDV",
    "signingProfileVersionArn": "arn:aws:signer:us-east-1:794038225525:/signing-profiles/signingProfile_oMUpmpwLjF6V/zcUrmFiZgG",
    "custodianRoleName": "nasco-c7n",
    "errorTopicArn": "arn:aws:sns:us-east-1:794038225525:c7n-errors",
    "signingProfileName": "signingProfile_oMUpmpwLjF6V",
    "scheduleGroupName": "CloudCustodian",
    "policySGId": "sg-011c5f8d0caeef81b",
    "custodianRoleArn": "arn:aws:iam::794038225525:role/nasco-admin/nasco-c7n",
    "scheduleRoleArn": "arn:aws:iam::794038225525:role/nasco-admin/nasco-c7n-schedule",
    "custodianAdminRoleArn": "arn:aws:iam::794038225525:role/nasco-admin/nasco-c7n-admin",
    "tenableOneRoleArn": "arn:aws:iam::794038225525:role/nasco-admin/nasco-tenable-one",
    "bedrockLogging": "Yes",
    "logicMonitorRoleArn": "arn:aws:iam::794038225525:role/nasco-admin/nasco-logicmonitor",
    "snsKMSKeyAliasName": "alias/nasco/sns",
    "cfLoggingBucketName": "cloudfront-logs-794038225525-us-east-1",
    "s3LoggingBucketName": "s3-access-logs-794038225525-us-east-1",
    "breakGlassRoleArn": "arn:aws:iam::794038225525:role/nasco-admin/nasco-break-glass",
    "permsBoundaryPolicyARN": "arn:aws:iam::794038225525:policy/nasco/builder-permissions-boundary",
    "deploymentBucketName": "deployment-794038225525-us-east-1",
    "opsPermsBoundaryPolicyARN": "arn:aws:iam::794038225525:policy/nasco/ops",
    "BaselineCloudFrontACLARN": "arn:aws:wafv2:us-east-1:794038225525:global/webacl/NASCO-CloudFront-Baseline/f9a429ba-ebcf-4787-95ae-269d348fe5c2",
    "TerraformStateBucketName": "tfstate-794038225525-us-east-1",
    "oidcProviderArn": "arn:aws:iam::794038225525:oidc-provider/api.bitbucket.org/2.0/workspaces/nascodevelopment/pipelines-config/identity/oidc",
    "BaselineConfigDeliveryChannel": "aws-controltower-BaselineConfigDeliveryChannel",
    "BaselineConfigRecorder": "aws-controltower-BaselineConfigRecorder",
    "LocalSecurityTopicName": "aws-controltower-SecurityNotifications",
    "LocalSecurityTopic": "arn:aws:sns:us-east-1:794038225525:aws-controltower-SecurityNotifications",
    "BaselineConfigRole": "arn:aws:iam::794038225525:role/aws-controltower-ConfigRecorderRole",
    "env": "dev"
}
export { COMPILED_CONSTANTS }